module.exports = __webpack_public_path__ + "static/img/01.9c108f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/eggenberger/01.jpg
// module id = 361
// module chunks = 1